<div (click)="hideContextMenu()">
  <div class="init-overlay" *ngIf="isInitializing"></div>
  <tn-loader></tn-loader>
  <tn-watermark></tn-watermark>
  <tn-context-menu></tn-context-menu>
  <router-outlet></router-outlet>
</div>
